import React, { useEffect } from "react";
import { Form } from "antd";
import { connect } from "react-redux";
import FormItem from "components/fields/FormItem";
import Card from "components/card";
import MDEditor from "@uiw/react-md-editor";
import ReactMarkdown from "react-markdown";
import CrudButtons from "components/button/crudbuttons";
import {
  getApplicantResumePreview, doSaveApplicantResumePreview
} from "../../../../redux/recruitment/recruitmentState";
import TextArea from "antd/es/input/TextArea";

const ResumePreview = ({applicant, isClientUser=false, getRecord, recordData, doUpdate}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if(applicant){
            getRecord({id:applicant.apl_id});
        }
    }, [getRecord, applicant]);

    useEffect(() => {
        if(recordData){
            console.log(recordData);
            form.setFieldsValue(recordData);
        }
    }, [recordData, form]);

    const onSubmit = (values) => {
        const payload = {
            id: applicant?.apl_id,
            art_preview_format: values.art_preview_format,
        };

        doUpdate(payload);
    };

    return (
        <div className="bg-white rounded-2xl max-h-[70vh]">
            {isClientUser ? 
                <Card className="markdown-preview flex px-8 flex-col rounded-2xl shadow-xl">
                    <ReactMarkdown>
                        {recordData?.art_preview_format}
                    </ReactMarkdown>
                </Card>
            : 
            
            <Form form={form} layout="vertical" className="form" onFinish={onSubmit}>
                <FormItem
                    className="font-medium mb-2"
                    name="art_preview_format"
                    noStyle
                    valuePropName="value"
                    getValueFromEvent={(value) => value}
                >
                    <MDEditor height={400} />
                </FormItem>
                
                <div className="w-full flex justify-end">
                    <CrudButtons
                        mode="edit"
                        recordId={0}
                        isModal
                        modalId="add-notes-modal"
                        moduleId={0}
                    />
                </div>
            </Form>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordData: state.recruitment.applicantResumePreview?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getApplicantResumePreview(id)),
  doUpdate: (data) => dispatch(doSaveApplicantResumePreview(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResumePreview);
